<template>
  <!-- Basic stream information -->
  <admin-modal v-show="show" :title="title" @cancel="$emit('close')">
    <template v-slot:body>
      <div v-if="streamInfo">
        <div class="modal__row">
          <!-- Stream name -->
          <div class="modal__field long-field">
            <span class="modal__label" title="Stream name">
              Stream
            </span>
            <input
              v-model="streamInfo.streamName"
              class="modal__input"
              disabled
            />
          </div>

          <!-- Stream Clipper ID -->
          <div class="modal__field long-field">
            <span class="modal__label" title="Stream Clipper ID">
              Stream ID
            </span>
            <input v-model="streamInfo.id" class="modal__input" disabled />
          </div>
        </div>

        <!-- Stream display name -->
        <div class="modal__row">
          <!-- WSE streaming URL -->
          <div class="modal__field long-field">
            <span class="modal__label" title="WSE streaming URL">
              Stream display name
            </span>
            <input
              v-model="streamInfo.streamDisplayName"
              class="modal__input"
              disabled
            />
          </div>
        </div>

        <div class="modal__row">
          <!-- WSE streaming URL -->
          <div class="modal__field long-field">
            <span class="modal__label" title="WSE streaming URL">
              Stream Host
            </span>
            <input
              v-model="streamInfo.streamHost"
              class="modal__input"
              disabled
            />
          </div>
        </div>

        <div class="modal__row">
          <!-- Backend API URL -->
          <div class="modal__field long-field">
            <span class="modal__label" title="Backend API URL">
              nDVR API
            </span>
            <input v-model="streamInfo.ndvrApi" class="modal__input" disabled />
          </div>
        </div>

        <div class="modal__row">
          <!-- Thumbnails, clips, DVRs storage URL -->
          <div class="modal__field long-field">
            <span
              class="modal__label"
              title="Thumbnails, clips, DVRs storage URL"
            >
              nDVR Nginx
            </span>
            <input
              v-model="streamInfo.ndvrNginx"
              class="modal__input"
              disabled
            />
          </div>
        </div>
      </div>

      <div v-else>
        No stream information
      </div>
    </template>

    <template v-slot:footer>
      <!-- Cancel button -->
      <div class="modal-btn cancel-btn" @click="$emit('close')">
        Close
      </div>

      <!-- Copy stream JSON-information to clipboard -->
      <div
        :class="{ copied: isJsonCopied }"
        class="modal-btn submit-btn"
        @click="copyJsonToClipboard"
      >
        {{ jsonCopyText }}
      </div>
    </template>
  </admin-modal>
</template>

<script>
import AdminModal from "@/components/admin/modals/AdminModal.vue";
import { setTimeout } from "timers";

// @group Dialog
// Shows detailed stream information
export default {
  name: "StreamInfoModal",
  components: {
    AdminModal
  },
  props: {
    // stream object
    streamInfo: {
      type: Object,
      required: true
    },
    // is modal shown
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      /** is stream info copied to JSON recently */
      isJsonCopied: false
    };
  },
  computed: {
    // @vuese
    // modal titile
    title() {
      return this.streamInfo?.channelName ?? "---";
    },
    // @vuese
    // JSON-formatted stream information for pasting to Mangomolo
    jsonStreamInfo() {
      const streamJsonable = {
        stream_id: this.streamInfo.id,
        stream_host: this.streamInfo.streamHost,
        ndvr_api: this.streamInfo.ndvrApi,
        ndvr_nginx: this.streamInfo.ndvrNginx,
        default_stream: this.streamInfo.streamName,
      };
      return JSON.stringify(streamJsonable, null, 2);
    },
    // @vuese
    // Text of 'Copy JSON' button
    jsonCopyText() {
      return this.isJsonCopied ? "Copied" : "Copy JSON";
    }
  },
  methods: {
    // @vuese
    // Copy JSON-formatted stream information to clipboard
    copyJsonToClipboard() {
      this.copyToClipboard(this.jsonStreamInfo);
      this.isJsonCopied = true;
      setTimeout(() => (this.isJsonCopied = false), 1000);
    },
    // @vuese
    // Copy text to clipboard
    // @arg text Text to copying
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
    }
  }
};
</script>

<style>
.modal__field.long-field {
  width: 100%;
}
.modal-btn.submit-btn {
  transition: background-color var(--fast-transition);
}
.modal-btn.submit-btn.copied {
  background-color: var(--success-color);
  border: none;
}
</style>
